import { createFileRoute } from "@tanstack/react-router";
import UkDealers from "@/pages/dealeri/UkDealers";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/fr/dealers/")({
  head: () => routeHead("/fr/dealers/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UkDealers />
  );
}
